import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, useId } from "react";
import classNames from "classnames";
import { CheckboxBase, CheckboxBaseProps } from "../../CheckboxBase";

import styles from "./styles.module.scss";

export type CheckboxGroupSimpleSize = "sm" | "md";


export type CheckboxGroupSimpleItemProps = Omit<CheckboxBaseProps, "checkboxBaseSize"> & {
  checkboxBaseClassName?: string,
  inputPosition?: "start" | "end",
  contentClassName?: string,
  checkboxSize?: CheckboxGroupSimpleSize,
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
}

export const CheckboxGroupSimpleItem = memo(forwardRef<HTMLSpanElement, CheckboxGroupSimpleItemProps>((
  {
    checkboxBaseClassName,
    inputPosition = "end",
    contentClassName,
    checkboxSize,
    children,
    className,
    disabled,
    id,
    labelProps,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[checkboxSize as keyof typeof styles],
        {
          [styles.disabled]: disabled,
          [styles.selected]: props.value,
          [styles.reverted]: inputPosition === "start",
        },
      )}
      htmlFor={realId}
    >
      <div className={classNames(styles.content, contentClassName)}>{children}</div>
      <CheckboxBase
        ref={ref}
        checkboxBaseSize={checkboxSize}
        className={classNames(styles.checkboxBase, checkboxBaseClassName)}
        disabled={disabled}
        id={realId}
        {...props}
      />
    </label>
  );
}));